import React, { useLayoutEffect, useRef } from "react";

type RenderGameCardProps = {
  isGameFinished: boolean;
  children: React.ReactNode;
};

// Компонент для отображения карточки игры с эффектом переворота
const RenderGameCard = ({ isGameFinished, children }: RenderGameCardProps) => {
  const frontRef = useRef<HTMLDivElement>(null);
  const winSquareRef = useRef<HTMLDivElement>(null);

  // пересчитываем размеры квадрата победы при изменении размеров окна
  useLayoutEffect(() => {
    const front = frontRef.current;
    const winSquare = winSquareRef.current;

    if (!front || !winSquare) return;

    const resize = () => {
      const size = Math.min(front.offsetWidth, front.offsetHeight);
      const sizeVw = (size / window.innerWidth) * 100;

      winSquare.style.width = `${sizeVw}vw`;
      winSquare.style.height = `${sizeVw}vw`;
    };

    resize();

    const observer = new ResizeObserver(resize);
    observer.observe(front);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="tableS-card-container">
      <div
        className={`tableS-card ${isGameFinished ? "tableS-card-flipped" : ""}`}
      >
        {/* Передняя сторона */}
        <div ref={frontRef} className="tableS-card-face tableS-card-front">
          {children}
        </div>

        {/* Задняя сторона */}
        <div className="tableS-card-face tableS-card-back">
          <div ref={winSquareRef} className="tableS-win-square">
            <img
              className="tableS-win-image"
              src="/img/umnichka.svg"
              alt="Победа"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenderGameCard;
